import React from 'react';

import PopupFooter from './PopupFooter';
import Share from './Share';
import tag from './Analytics';


function Success(props) {

  tag('formsuccess');

  return (
    <div className="gp-popup gp-popup-success">
      <div className="gp-close-icon" onClick={props.onClose}>
        <span className="icon">
          <i className="fa fa-window-close"></i>
        </span>
      </div>
      <div className="gp-content gp-no-counter">
        <div className="content">
          <p>
            <b>Merci beaucoup d’avoir affiché votre engagement contre le nucléaire.</b>&nbsp;Merci aussi de votre soutien aux 34 activistes de Greenpeace dont le procès aura lieu prochainement à Valence. Ils et elles ont agi au nom de l’intérêt général, pour dénoncer le vieillissement des centrales nucléaires comme celle de Tricastin. Soyons encore plus nombreux·ses&nbsp;!

          </p>
          <p>
          Rendez-vous dimanche 15 novembre, pour <a href="https://www.facebook.com/events/1239470703084190" target="_blank" rel="noopener noreferrer">une conférence en ligne en direct sur le nucléaire</a>, en attendant de connaître la date du procès des 34 activistes.
          </p>

          <p>
            <b>Faites passer le mot sur les réseaux sociaux&nbsp;:</b>
          </p>

        </div>
        <Share/>
        <PopupFooter/>
      </div>
    </div>
  )
}

export default Success;
